import { capitalize, Card, Typography } from "@mui/material";
import { classes } from "common/theme/theme";
import { couplerTypeToLocaleString } from "common/utils/enumTranslations";
import {
  friendlyScvOutputName,
  ImplementConfiguration,
} from "portal/utils/atkEquipment";
import { LibraryCardDetailRow } from "portal/components/atk/LibraryCardDetailRow";
import { ScvInput, ScvOutput } from "protos/atk/autotractor";
import { useTranslation } from "react-i18next";
import React from "react";

type ImplementAndInput = { implement: ImplementConfiguration; input: ScvInput };

type RigConnectionsSelection =
  | { scvInput: ImplementAndInput | undefined; scvOutput?: undefined }
  | { scvInput?: undefined; scvOutput: ScvOutput | undefined };

export const ScvOutputListItem: React.FC<{
  selection: RigConnectionsSelection;
  setSelection: (selection: RigConnectionsSelection) => void;
  output: ScvOutput;
  connectedInputs: ScvInput[];
}> = ({ output, connectedInputs, selection, setSelection }) => {
  const { t } = useTranslation();

  return (
    <li className="list-none cursor-pointer">
      <div
        role="button"
        className={classes("flex flex-row w-full py-2 px-4", {
          "bg-darken-100 dark:bg-lighten-200": selection.scvOutput === output,
        })}
        onClick={() => setSelection({ scvOutput: output })}
        tabIndex={0}
      >
        <Typography className="align-middle h-full">
          {capitalize(friendlyScvOutputName(t, output))}
        </Typography>
        <Typography
          color={connectedInputs.length === 0 ? "secondary" : undefined}
          className="flex-1 text-right h-full"
        >
          {connectedInputs.length > 0 ? (
            <Typography>
              {t("views.autotractor.rigDetails.connections.connectedTo")}
              {connectedInputs.map((input, index) => (
                <React.Fragment key={index}>
                  <br />
                  {input.function}
                </React.Fragment>
              ))}
            </Typography>
          ) : (
            <>{t("views.autotractor.rigDetails.connections.noConnections")}</>
          )}
        </Typography>
      </div>
    </li>
  );
};

export const ScvOutputDetailView: React.FC<{ output: ScvOutput }> = ({
  output,
}) => {
  const { t } = useTranslation();

  return (
    <Card className="p-4 flex flex-col gap-4 border-2 border-solid rounded-lg">
      <Typography className="text-xl">
        <strong>
          {t("views.autotractor.rigDetails.connections.selectedSCV")}
        </strong>
        {friendlyScvOutputName(t, output)}
      </Typography>
      <LibraryCardDetailRow
        label="Hydraulic coupler"
        value={<>{couplerTypeToLocaleString(t, output.coupler)}</>}
      />
    </Card>
  );
};
